import React from 'react';
import { CheckCircle2, AlertCircle, MinusCircle, X } from 'lucide-react';

// Compact outcome list for a "send images to Square" run — one line per product,
// with the reason whenever an item didn't go up.

const TONE = {
  sent: { Icon: CheckCircle2, cls: 'text-green-400' },
  skipped: { Icon: MinusCircle, cls: 'text-white/40' },
  failed: { Icon: AlertCircle, cls: 'text-red-400' },
};

export default function ImagePushResult({ result, onClose }) {
  if (!result) return null;

  return (
    <div className="mt-4 border border-white/10 bg-[#111115]">
      <div className="flex items-center gap-3 px-4 py-3 border-b border-white/5">
        <p className="text-white text-sm font-bold">
          {result.sent} sent to Square
          {result.skipped > 0 && <span className="text-white/40 font-normal"> · {result.skipped} skipped</span>}
          {result.failed > 0 && <span className="text-red-400 font-normal"> · {result.failed} failed</span>}
        </p>
        <button onClick={onClose} className="ml-auto text-white/30 hover:text-white p-1 shrink-0" title="Dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="max-h-72 overflow-y-auto divide-y divide-white/5">
        {result.results.map((r) => {
          const { Icon, cls } = TONE[r.status] || TONE.skipped;
          return (
            <div key={r.product_id} className="flex items-start gap-3 px-4 py-2.5">
              <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${cls}`} />
              <div className="min-w-0">
                <p className="text-white text-xs font-bold truncate">{r.name || r.product_id}</p>
                <p className="text-white/40 text-[11px]">
                  {r.status === 'sent'
                    ? `Sent${r.rehosted ? ' · image re-hosted' : ''}`
                    : r.reason}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}